import { Injectable } from "@angular/core";
import { StepperInterface } from "@avla/ui-design/commons";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StepService {
  public static STEP = "step";
  public static step: StepInterface | null = null;
  public step = new Subject<StepInterface>();
  public stepListener = this.step.asObservable();
  public static stepsCreateProject: StepperInterface[] = [
    {
      label: 'Cliente',
      step: 'current'
    },
    {
      label: 'Proyecto',
      step: 'next'
    },
    {
      label: 'Financiamiento',
     step: 'next'
    },
    {
      label: 'Documentación',
     step: 'next'
    },
    {
      label: 'Resultado',
      step: 'completed'
    },
  ];

  public static stepsOneByOne: StepperInterface[] = [
    {
      label: 'Datos póliza',
      step: 'current'
    },
    {
      label: 'Cotizar',
      step: 'next'
    },
    {
      label: 'Emitir',
      step: 'completed'
    }
  ];
  
  constructor() {
    if( !StepService.step ) {
      const s = sessionStorage.getItem(StepService.STEP);
      const step = s ? JSON.parse(s) : null;
      this.setStepInit(step);
    }
  }

  public setStepInit(step: StepInterface) {
    sessionStorage.setItem(StepService.STEP, JSON.stringify(step));
    StepService.step = step;
    this.step.next(step);
  }

  public setStep(step: number) {
    const s = StepService.step;
    if(s) {
      s.step = step;
      this.setStepInit(s);
    }
  }

  public clear() {
    sessionStorage.removeItem(StepService.STEP);
    StepService.step = null;
    this.step.next(null);
  }
}
export interface StepInterface {
  step: number;
}